import React, {Component} from 'react';
import { connect } from 'react-redux'
import {get,post} from 'axios';
import configure from '../configure';

import App from '../pages/app';

//どのstateをpropsでrecieveするか
const mapStateToProps = (state, ownProps) => {
  return {
    isFetching: state.isFetching,
    items: state.filteredItems,
    date: state.date,
    selectedId: state.selectedId,
    selectedDate: state.selectedDate,
  }
}

//どのactionCreatorをpropsでrecieveするか
const mapDispatchToProps = dispatch => {
  return {
    //初期のデータ取得
    init: ()=>{
      dispatch({type: 'FETCHING'});
      dispatch({type: 'PARSE_HASH'});

      get('/assets2/feature/peanuts/data/items.json').then(function(response){
        dispatch({type: 'LOADED'});
        dispatch({type: 'PUSH_ITEMS', payload:response.data});
        dispatch({type: 'PUSH_FILTERED_ITEMS'});
      }).catch(function(reason){
        dispatch({type: 'LOADED'});
        dispatch({type: 'ERROR'});
      });
    },
    //APIにpost
    sendData: (date)=>{
      dispatch({type: 'FETCHING'});

      post(configure.API_URL(), date).then(function(response){
        dispatch({type: 'SEND_DATA'});
      }).catch(function(reason){
        dispatch({type: 'LOADED'});
        dispatch({type: 'ERROR'});
      });
    },
    //日付を選択
    selectDate: (id)=>{
      dispatch({
        type: 'SET_DATE',
        payload: id
      });
    },
    //POSTするformの参照を渡す
    saveFormRef: (target)=>{
      dispatch({
        type: 'FORM_REF',
        payload: target
      });
    }
  }
}

const AppContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(App);

export default AppContainer;



// WEBPACK FOOTER //
// ./source/javascripts/containers/appcontainer.js